<template>
  <div class="card shadow p-md-2">
    <div class="card-body">
      <div class="row">
        <div class="col-4 col-md-2 d-flex mb-auto my-md-auto">
          <div
            class="d-flex border border-blue-300
              rounded-circle overflow-hidden image-width"
          >
            <img
              class="img-fluid m-auto"
              :src="company.logo"
              :alt="company.name"
            >
          </div>
        </div>
        <div class="col-8 mb-3 mb-md-0 d-md-none">
          <div class="h5 mb-2 mb-md-0">
            {{ company.name }}
          </div>
          <div
            class="lead fw-bold text-primary mb-md-0"
            v-html="perk.description"
          />
        </div>
        <div class="col-12 col-md-7 col-xl-8 d-flex flex-column">
          <div class="h5 mb-0 mb-md-2 d-none d-md-flex">
            {{ company.name }}
          </div>
          <div
            class="lead fw-bold text-primary mb-md-2 d-none d-md-flex"
            v-html="perk.description"
          />
          <div
            class="text-gray-500"
            v-html="company.description"
          />
        </div>
        <div class="col-12 col-md-3 col-xl-2 d-flex">
          <a
            class="btn btn-primary text-nowrap w-100 my-auto"
            target="_blank"
            :href="perk.link"
          >
            <div class="d-flex flex-row">
              <div class="ms-auto me-1">
                En profiter
              </div>
              <v-icon
                icon="arrow-white-right"
                class="me-auto"
              />
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    company: {
      type: Object,
      default: () => ({
        name: 'Qonto',
        logo: 'Logo',
        description: `Ouvrez dès à présent votre compte pro 100% en ligne avec
        Qonto, sans devoir vous déplacer. Qonto est l'alternative bancaire
        idéale destinée aux TPE-PME, Startups, Freelances.`,
      }),
    },
    perk: {
      type: Object,
      default: () => ({
        link: 'www.qonto.eu',
        callToAction: 'Je m\'inscris',
        description: '5% sur l’ouverture de votre compte',
      }),
    },
  },
};
</script>
<style scoped>
.image-width {
  height: 100px;
  width: 100px;
}
@media screen and (max-width: 576px) {
  .image-width {
    height: 80px;
    width: 80px;
  }
}
</style>
